var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-timepicker',{attrs:{"value":_vm.formattedTime,"format":_vm.format,"minute-interval":_vm.minuteInterval,"second-interval":_vm.secondInterval,"hide-clear-button":_vm.hideClearButton},on:{"change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }